import axios from '../utils/axios';

export default function verifyRecruiter (adminId, data) {
    return axios.post(`/admin/${adminId}/verify-recruiter`, data);
}